import { render } from "./PopularTopics.vue?vue&type=template&id=4afd4266"
import script from "./PopularTopics.vue?vue&type=script&lang=js"
export * from "./PopularTopics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__